import {
  requestType,
  succeedType,
  failedType,
  REQUEST_PASSWORD_RESET,
  RESET_PASSWORD,
  VERIFY_RESET_PASSWORD_TOKEN,
} from "./../actions/actionTypes";

const initState = {
  error: false,
  verifying_token: false,
  requesting_password_reset: false,
  resetting_password: false,
  reset_password_message: "",
  reset_password_data: {},
};

export const resetPasswordReducer = (state = initState, action) => {
  switch (action.type) {
    case requestType(REQUEST_PASSWORD_RESET):
      return {
        ...state,
        requesting_password_reset: true,
      };
    case failedType(REQUEST_PASSWORD_RESET):
      return {
        ...state,
        requesting_password_reset: false,
      };
    case succeedType(REQUEST_PASSWORD_RESET):
      return {
        ...state,
        requesting_password_reset: false,
        reset_password_message: action.reset_password_message,
      };
    case requestType(RESET_PASSWORD):
      return {
        ...state,
        resetting_password: true,
      };
    case failedType(RESET_PASSWORD):
      return {
        ...state,
        resetting_password: false,
      };
    case succeedType(RESET_PASSWORD):
      return {
        ...state,
        resetting_password: false,
        reset_password_message: action.reset_password_message,
        redirect_url: action.redirect_url,
        app_salt: action.app_salt,
      };
    case requestType(VERIFY_RESET_PASSWORD_TOKEN):
      return {
        ...state,
        error: false,
        verifying_token: true,
      };
    case failedType(VERIFY_RESET_PASSWORD_TOKEN):
      return {
        ...state,
        error: true,
        verifying_token: false,
      };
    case succeedType(VERIFY_RESET_PASSWORD_TOKEN):
      return {
        ...state,
        error: false,
        verifying_token: false,
        reset_password_data: action.reset_password_data,
      };
    default:
      return state;
  }
};
